import type { Photo, RunDetail, RunsIndex } from './types';

export async function loadRunsIndex(): Promise<RunsIndex> {
  const res = await fetch('/data/runs.json', { cache: 'no-cache' });
  if (!res.ok) throw new Error(`Failed to load runs.json (${res.status})`);
  return (await res.json()) as RunsIndex;
}

export async function loadPhotos(): Promise<Photo[]> {
  const res = await fetch('/data/photos.json', { cache: 'no-cache' });
  if (res.status === 404) return [];
  if (!res.ok) throw new Error(`Failed to load photos.json (${res.status})`);
  const parsed = (await res.json()) as { photos?: Photo[] };
  return parsed.photos ?? [];
}

const detailCache = new Map<string, Promise<RunDetail>>();

export function loadRunDetail(id: string): Promise<RunDetail> {
  const cached = detailCache.get(id);
  if (cached) return cached;
  const p = fetch(`/data/runs/${encodeURIComponent(id)}.json`, { cache: 'force-cache' }).then(async (res) => {
    if (!res.ok) throw new Error(`Failed to load run ${id} (${res.status})`);
    return (await res.json()) as RunDetail;
  });
  detailCache.set(id, p);
  return p;
}
